import { useState } from "react";
import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/Navigation/NavBar";
import { auth, googleProvider } from "../../firebase";
import {
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import navLogo from '../../assests/navLogo.png';
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { doc, getDoc, getFirestore, serverTimestamp, setDoc, updateDoc } from "firebase/firestore";

function LoginPage() {
const [activeTab, setActiveTab] = useState("signup");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const db = getFirestore();

  const handleGoogleAuth = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const userRef = doc(db, "Users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        // New user → create doc
        await setDoc(userRef, {
          created_time: serverTimestamp(),
          email: user.email,
          handleName: "Users",
          lastLoginDate: serverTimestamp(),
          points: 10,
          uid: user.uid,
        });
      } else {
        // Existing user → update last login
        await updateDoc(userRef, {
          lastLoginDate: serverTimestamp(),
        });
      }

      navigate("/profile");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  const handleAuth = async () => {
    try {
      if (activeTab === "signup") {
        if (password !== confirmPassword) {
          alert("Passwords do not match!");
          return;
        }
        const result = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        const user = result.user;

        // Always create doc for new email signup
        await setDoc(doc(db, "Users", user.uid), {
          created_time: serverTimestamp(),
          email: user.email,
          handleName: "Users",
          lastLoginDate: serverTimestamp(),
          points: 10,
          uid: user.uid,
        });
      } else {
        const result = await signInWithEmailAndPassword(auth, email, password);
        const user = result.user;

        // Update last login only
        const userRef = doc(db, "Users", user.uid);
        await updateDoc(userRef, {
          lastLoginDate: serverTimestamp(),
        });
      }
      navigate("/profile");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <>
      <NavBar />
      <div className="min-h-screen bg-gray-100 text-gray-900 flex justify-center mt-20">
        <div className="max-w-screen-xl m-0 sm:m-10 bg-white shadow sm:rounded-lg flex justify-center flex-1">
          <div className="lg:w-1/2 xl:w-5/12 p-6 sm:p-12">
            <div>
              <img src={navLogo} className="w-32 mx-auto" alt="Logo" />
            </div>

            {/* Tabs */}
            <div className="mt-6 flex justify-center space-x-6 border-b">
              <button
                className={`pb-2 text-lg font-semibold ${
                  activeTab === "signup"
                    ? "border-b-2 border-[#316391] text-[#316391]"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("signup")}
              >
                Sign Up
              </button>
              <button
                className={`pb-2 text-lg font-semibold ${
                  activeTab === "login"
                    ? "border-b-2 border-[#316391] text-[#316391]"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("login")}
              >
                Login
              </button>
            </div>

            {/* Content */}
            <div className="mt-8 flex flex-col items-center">
              <h1 className="text-2xl xl:text-3xl font-extrabold">
                {activeTab === "signup" ? "Sign up" : "Login"}
              </h1>
              <div className="w-full flex-1 mt-8">
                <div className="flex flex-col items-center">
                  <button
                    onClick={handleGoogleAuth}
                    className="w-full max-w-xs font-bold shadow-sm rounded-lg py-3 bg-[#8BD1C7] text-gray-800 flex items-center justify-center transition-all duration-300 ease-in-out focus:outline-none hover:shadow"
                  >
                    <div className="bg-white p-2 rounded-full">
                      {/* Google Icon */}
                      <svg className="w-4" viewBox="0 0 533.5 544.3">
                        <path
                          d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z"
                          fill="#4285f4"
                        />
                        <path
                          d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z"
                          fill="#34a853"
                        />
                        <path
                          d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z"
                          fill="#fbbc04"
                        />
                        <path
                          d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z"
                          fill="#ea4335"
                        />
                      </svg>
                    </div>
                    <span className="ml-4">
                      {activeTab === "signup" ? "Sign Up" : "Login"} with Google
                    </span>
                  </button>
                </div>

                <div className="my-12 border-b text-center">
                  <div className="leading-none px-2 inline-block text-sm text-gray-600 tracking-wide font-medium bg-white transform translate-y-1/2">
                    Or {activeTab === "signup" ? "sign up" : "login"} with e-mail
                  </div>
                </div>

                <div className="mx-auto max-w-xs">
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-[#316391] focus:bg-white"
                    type="email"
                    placeholder="Email"
                  />

                  {/* Password Field with Eye Icon */}
                  <div className="relative w-full mt-5">
                    <input
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      className="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-[#316391] focus:bg-white"
                    />
                    <div
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <EyeSlashIcon className="w-5 h-5 text-gray-500" />
                      ) : (
                        <EyeIcon className="w-5 h-5 text-gray-500" />
                      )}
                    </div>
                  </div>

                  {/* Confirm Password Field for Sign Up */}
                  {activeTab === "signup" && (
                    <div className="relative w-full mt-5">
                      <input
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        type={showPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        className="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-[#316391] focus:bg-white"
                      />
                    </div>
                  )}

                  <button
                    onClick={handleAuth}
                    className="mt-5 tracking-wide font-semibold bg-[#316391] text-white w-full py-4 rounded-lg hover:bg-[#234567] transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                  >
                    <span className="ml-3">
                      {activeTab === "signup" ? "Sign Up" : "Login"}
                    </span>
                  </button>

                  {activeTab === "signup" && (
                    <p className="mt-6 text-xs text-gray-600 text-center">
                      I agree to abide by Nextloop's{" "}
                      <a
                        href="/terms"
                        className="border-b border-[#316391] border-dotted"
                      >
                        Terms of Service
                      </a>{" "}
                      and its{" "}
                      <a
                        href="/privacy-policy"
                        className="border-b border-[#316391] border-dotted"
                      >
                        Privacy Policy
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Image section */}
          <div className="flex-1 bg-indigo-100 text-center hidden lg:flex">
            <div
              className="m-12 xl:m-16 w-full bg-contain bg-center bg-no-repeat"
              style={{
                backgroundImage:
                  "url('https://storage.googleapis.com/devitary-image-host.appspot.com/15848031292911696601-undraw_designer_life_w96d.svg')",
              }}
            ></div>
          </div>
        
        </div>
      </div>
      <Footer />
    </>
  );
}

export default LoginPage;
